import { useTenantCode } from 'utils/hooks/useTenantConfig';

/* Enum rules: values should not reflect nested routing - that is, one flat route per key */
export enum ROUTES {
  DETECTED_PROGRAM_ALERTS = 'program-alerts',
  BUSINESS_EVENTS = 'business-events',
  BUSINESS_EVENTS_EDIT = 'edit',
  PROFILE = 'profile',
  MY_ACCOUNT = 'my-account',
  SETTINGS = 'settings',
  PROGRAM_ALERTS_DETAILS = 'details',
  SECURITY_POLICIES = 'security-permissions',
  SECURITY_POLICIES_DETAILS = 'details',
  SECURITY_POLICIES_DETAILS_ACTOR_TAB = 'actor',
  SECURITY_POLICIES_DETAILS_RELATIONSHIP_TAB = 'relationship',
  SECURITY_POLICIES_DETAILS_ACTIONS_TAB = 'actions',
  SECURITY_POLICIES_DETAILS_RESOURCE_TAB = 'resource',
  REPORTS = 'reports',

  SETTINGS_PROGRAM_ALERTS = 'program-alerts'
}

export enum URL_PARAMS {
  PROGRAM_ALERT_DETAILS = 'anomalyUid',
  SECURITY_POLICIES_DETAILS = 'policyUid',
  BUSINESS_EVENTS_EDIT = 'eventUid'
}

export type SettingsTabs = ROUTES.SECURITY_POLICIES;

export type SettingsSecurityPolicyDetailTabs =
  | ROUTES.SECURITY_POLICIES_DETAILS_ACTOR_TAB
  | ROUTES.SECURITY_POLICIES_DETAILS_RELATIONSHIP_TAB
  | ROUTES.SECURITY_POLICIES_DETAILS_ACTIONS_TAB
  | ROUTES.SECURITY_POLICIES_DETAILS_RESOURCE_TAB;

export interface RoutePaths {
  securityPolicies: string;
  settingsProgramAlerts: string;
  detectedProgramAlerts: string;
  businessEvents: string;
}

export const useRoutes = (): RoutePaths => {
  const tenantCode = useTenantCode();
  return {
    securityPolicies: `/${tenantCode}/${ROUTES.SETTINGS}/${ROUTES.SECURITY_POLICIES}`,
    settingsProgramAlerts: `/${tenantCode}/${ROUTES.SETTINGS}/${ROUTES.SETTINGS_PROGRAM_ALERTS}`,
    detectedProgramAlerts: `/${tenantCode}/${ROUTES.DETECTED_PROGRAM_ALERTS}`,
    businessEvents: `/${tenantCode}/${ROUTES.SETTINGS}/${ROUTES.BUSINESS_EVENTS}`
  };
};
